/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RemovePromoCampaignManagerOptions,
  RemovePromoCampaignManagerStatus204,
  RemovePromoCampaignManagerStatus400,
  RemovePromoCampaignManagerStatus401,
  RemovePromoCampaignManagerStatus403,
  RemovePromoCampaignManagerStatus404,
  RemovePromoCampaignManagerStatus500,
} from '../types/RemovePromoCampaignManager'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { removePromoCampaignManager } from '../clients/removePromoCampaignManager'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const removePromoCampaignManagerMutationKey = () =>
  [{ url: '/v1/promo_campaigns/:trading_challenge_id/managers/:manager_id' }] as const

export function removePromoCampaignManagerMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = removePromoCampaignManagerMutationKey()
  return mutationOptions<
    RemovePromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | RemovePromoCampaignManagerStatus400
      | RemovePromoCampaignManagerStatus401
      | RemovePromoCampaignManagerStatus403
      | RemovePromoCampaignManagerStatus404
      | RemovePromoCampaignManagerStatus500
    >,
    RemovePromoCampaignManagerOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return removePromoCampaignManager({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description ADMIN only. Idempotent DELETE with no body. QR campaign grants are independent of home tenant and affiliate programs. Removal takes effect on the next protected request after commit; already authorized reads/downloads may finish. Batch issuance and removal serialize on the campaign lock.
 * @summary Remove QR campaign access for an Affiliate Manager
 * {@link /v1/promo_campaigns/:trading_challenge_id/managers/:manager_id}
 */
export function useRemovePromoCampaignManager<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RemovePromoCampaignManagerStatus204,
      ResponseErrorConfig<
        | RemovePromoCampaignManagerStatus400
        | RemovePromoCampaignManagerStatus401
        | RemovePromoCampaignManagerStatus403
        | RemovePromoCampaignManagerStatus404
        | RemovePromoCampaignManagerStatus500
      >,
      RemovePromoCampaignManagerOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? removePromoCampaignManagerMutationKey()

  const baseOptions = removePromoCampaignManagerMutationOptions(config) as UseMutationOptions<
    RemovePromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | RemovePromoCampaignManagerStatus400
      | RemovePromoCampaignManagerStatus401
      | RemovePromoCampaignManagerStatus403
      | RemovePromoCampaignManagerStatus404
      | RemovePromoCampaignManagerStatus500
    >,
    RemovePromoCampaignManagerOptions,
    TContext
  >

  return useMutation<
    RemovePromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | RemovePromoCampaignManagerStatus400
      | RemovePromoCampaignManagerStatus401
      | RemovePromoCampaignManagerStatus403
      | RemovePromoCampaignManagerStatus404
      | RemovePromoCampaignManagerStatus500
    >,
    RemovePromoCampaignManagerOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RemovePromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | RemovePromoCampaignManagerStatus400
      | RemovePromoCampaignManagerStatus401
      | RemovePromoCampaignManagerStatus403
      | RemovePromoCampaignManagerStatus404
      | RemovePromoCampaignManagerStatus500
    >,
    RemovePromoCampaignManagerOptions,
    TContext
  >
}
